import cx from "classnames";
import { Loadable } from "common/Loadable";
import fetchJSON from "lib/fetchJSON";
import { useFormatMessage } from "lib/localization";
import _ from "lodash";
import React from "react";
import { defineMessages } from "react-intl";
import styles from "./Organizations.scss";

const messages = defineMessages({
  loading: {
    id: "Organizations.loading",
    defaultMessage: "Loading your Organizations",
  },
});

export class Organizations extends React.PureComponent {
  render() {
    const {
      loadableResources: { results },
      collapsed,
    } = this.props;

    if (results.length === 0) {
      return null;
    }

    return (
      <div className={cx(styles.Organizations, collapsed && styles.collapsed)}>
        {results.map((org) => (
          <div
            data-tip
            key={org.url}
            title={org.name}
            data-tippy-placement={collapsed ? "right" : "bottom"}
            className={styles.organization}
          >
            <a href={org.url} style={{ height: "44px" }}>
              <img src={org.logo} width={44} height={44} />
            </a>
          </div>
        ))}
      </div>
    );
  }
}

const loadInitialResources = _.memoize((currentUser) =>
  fetchJSON(`/users/${currentUser.id}/memberships?include_inactive=true`)
);

export const LoadableOrganizations = (props) => {
  const fm = useFormatMessage();
  return (
    <Loadable
      {...props}
      component={Organizations}
      loadingText={fm(messages.loading)}
      resourceLoaded={() => loadInitialResources(props.currentUser)}
    />
  );
};
